import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../../redux/hooks";
import { heights } from "../../../../styles/romeu/heights";
import { sortArray } from "../../../../utils";
import { CustomDetailsList } from "../../../common/customDetailsList/customDetailsList";
import { Skeleton } from "../../../common/skeleton/skeleton";
import { ManagementAuthorizedTransportUnitNumberColumn } from "./column/column";
import { fetchManagementAuthorizedTransportUnitNumberListAction } from "../../../../redux/actions/management/authorizedTransportUnitNumber/authorizedTransportUnitNumber";
import { SkeletonSizes } from "../../../../common/constants";

export const ManagementAuthorizedTransportUnitNumberList = () => {
    const { list, loading, sort } = useAppSelector((state) => state.managementAuthorizedTransportUnitNumberList);
    const dispatch = useAppDispatch();

    const renderColumns = () => {
        return ManagementAuthorizedTransportUnitNumberColumn();
    };

    useEffect(() => {
        list === undefined && dispatch(fetchManagementAuthorizedTransportUnitNumberListAction());
    }, [list]);

    return !loading ? (
        <CustomDetailsList
            data={sortArray(list ?? [], sort)}
            renderColumns={renderColumns}
            height={heights.management.tables}
        />
    ) : (
        <Skeleton rows={SkeletonSizes.DEFAULT} />
    );
};
